import { render } from "./BaseCheckBoxBudget.vue?vue&type=template&id=bbf9ce8e&scoped=true"
import script from "./BaseCheckBoxBudget.vue?vue&type=script&lang=js"
export * from "./BaseCheckBoxBudget.vue?vue&type=script&lang=js"

import "./BaseCheckBoxBudget.vue?vue&type=style&index=0&id=bbf9ce8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf9ce8e"]])

export default __exports__